import React, { useState, useEffect } from "react";
import { format, parse } from "date-fns";
import { withStyles } from "@material-ui/core/styles";
import createStyles from "@material-ui/core/styles/createStyles";
import { Theme } from "@material-ui/core/styles/createMuiTheme";
import { withRouter } from "react-router-dom";
import Dialog from "@material-ui/core/Dialog";
import DeleteIcon from "@material-ui/icons/Delete"
import DialogContent from "@material-ui/core/DialogContent";
import Typography from "@material-ui/core/Typography";
import { RouteComponentProps } from "react-router";
import { stableSort, getSorting } from "../../../tools/sortingTools";
import UiDialogTitle from "../../common/UiDialogTitle";
import UiButton from "../../common/UiButton";
import UiInput from "../../common/UiInput";
import UiDialogActions from "../../common/UiDialogActions";
import BatchType from "../../../types/Batch";
import UserType from "../../../types/User";

const styles = (theme: Theme) =>
  createStyles({
    formControl: {
      marginTop: theme.spacing.unit,
      marginBottom: theme.spacing.unit,
      minWidth: "100%",
    },
    titre: {
      minWidth: "550px",
    },
    deleteIcon: {
      marginRight: theme.spacing.unit 
    }
  });

interface PropsType extends RouteComponentProps<any>, React.Props<any> {
  batch?: BatchType;
  selected?: any[];
  onSave: any;
  onClose: any;
  open: boolean;
  classes: any;
  users: UserType[];
  deleteDeadline?: Function;
}

const BatchFormDialog = (props: PropsType) => {
  const {
    batch,
    onSave,
    open,
    onClose,
    selected,
    deleteDeadline,
    classes,
  } = props;
  const [values, setValues] = useState({
    ids: selected,
    labelerId: "NULL",
    deadline: "",
  });
  const [deadlineError, setDeadlineError] = useState("");

  const todayStr = format(new Date(), "YYYY-MM-DD");

  const validateDeadline = (deadline: string) => {
    if (!deadline) {
      setDeadlineError("");
      return true;
    }
    if (deadline < todayStr) {
      setDeadlineError("La date limite doit être postérieure ou égale à la date actuelle.");
      return false;
    }
    setDeadlineError("");
    return true;
  };

  const handleChange = (e: any) => {
    e.stopPropagation();
    const { name, value } = e.target;
    if (name === "deadline") {
      validateDeadline(value);
    }
    setValues({ ...values, [name]: value });
  };

  useEffect(() => {
    setValues({ ...values, ids: selected });
  }, [selected]);

  useEffect(() => {
    const datas: any = {};
    if (batch) {
      if (batch.deadline) {
        datas.deadline = format(batch.deadline, "YYYY-MM-DD");
      }
      if (batch.labelerId) {
        datas.labelerId = batch.labelerId;
      }
    }
    setValues({ ...values, ...datas });
  }, [batch]);

  const handleSubmit = (e: any) => {
    e.preventDefault();
    e.stopPropagation();
    if (!validateDeadline(values.deadline)) {
      return;
    }
    const { labelerId, deadline, ids } = values;
    onSave({
      ids,
      deadline: deadline === "" ? null : parse(deadline).toISOString(),
    });
  };

  const handleDelete = () => {
    if (deleteDeadline) {
      deleteDeadline(batch);
    }
  };

  return (
    <Dialog
      open={open}
      onClose={onClose}
      aria-labelledby="list-actif-title"
      fullWidth
      maxWidth="sm"
    >
      <form onSubmit={handleSubmit}>
        <UiDialogTitle
          onCloseClick={onClose}
          title={`${
            batch && batch.deadline ? "Modifier la" : "Assigner une"
          } date limite`}
        />
        <DialogContent>
          <UiInput
            label="Date limite"
            name="deadline"
            type="date"
            value={values.deadline}
            inputProps={{ min: todayStr }}
            onChange={handleChange}
            required={false}
          />
          {deadlineError && (
            <Typography color="error" variant="body2" style={{ marginTop: 8 }}>
              {deadlineError}
            </Typography>
          )}
        </DialogContent>
        <UiDialogActions style={{ marginRight: 23 }}>
          {deleteDeadline && (
            <UiButton
              variant="contained"
              color="primary"
              onClick={handleDelete}
              disabled={!(batch && batch.deadline)}
            >
              <DeleteIcon className={classes.deleteIcon}/>
              Supprimer
            </UiButton>
          )}
          <UiButton
            variant="contained"
            color="secondary"
            type="submit"
            disabled={!!deadlineError}
          >
            Valider
          </UiButton>
        </UiDialogActions>
      </form>
    </Dialog>
  );
};

export default withStyles(styles)(withRouter(BatchFormDialog));
